
import {  GetLeadByID, UpdateLeadsByID } from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useLocation,useNavigate} from "react-router-dom";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const EditLead = () => {
  let query = useQuery();
  const LeadID = query.get("LeadID");
  const navigate=useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  var apiUrl = {};
  const { register, handleSubmit, setValue, formState,reset } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const[LID,setLID] = useState();
  const token = localStorage.getItem("jwtToken");
const GetVendorDetailsById = () => {
  const GetapiUrl = `${GetLeadByID.APIURL}?LeadID=${LeadID}`;

  Axios.get(GetapiUrl, { headers: { Authorization: `Bearer ${token}` } })
    .then((result) => {
      setValue("fullName",result.data[0].fullName)
      setValue("email",result.data[0].email)
      setValue("phoneNumber",result.data[0].phoneNumber)
      setValue("companyName",result.data[0].companyName)
      setValue("domain",result.data[0].domain)
      setValue("dateOfBirth",result.data[0].dateOfBirth)
      setValue("websiteURL",result.data[0].websiteURL)
      setValue("linkdinUrl",result.data[0].linkdinUrl)
      setLID(result.data[0].id)

    })
  }
  const onSubmit = (data, e) => {
    e.preventDefault();
    updateData(data);
  return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }
  const email = localStorage.getItem("email")

  const updateData = async(data) => {
    const params={
      "id":LID,
      "fullName": data.fullName,
      "email": data.email,
   "phoneNumber":data.phoneNumber,
   "companyName": data.companyName,
   "domain":data.domain,
   "dateOfBirth": data.dateOfBirth,
   "websiteURL":data.websiteURL,
   "linkdinUrl": data.linkdinUrl,
   "updatedBy": email

 }
 apiUrl = UpdateLeadsByID.APIURL;
 Axios.post(apiUrl, params, {
   headers: {
     'Content-Type': 'application/json',    
     'Authorization': `Bearer ${token}`,
   } })
   .then((result) => {
          if (result.data === "Lead updated successfully.") {
       // GetConsultantProfile();
     Swal.fire({
         position: 'center',
         icon: 'success',
         title: 'Updated Successfully ',
         showConfirmButton: false,
         timer: 5000
       })
       // toast.success('Data Saving', {autoClose:5000})
       navigate("/Employer/ListofLeads")

     }
     else {
       // toast.error('Issue with data format', {autoClose:5000})
       Swal.fire({
         position: 'center',
         icon: 'error',
         title: 'Add correct Details',
         showConfirmButton: false,
         timer: 5000
       })
     }

   }).catch(
     function (error) {
       console.log("Error" + error)
     })

}



  useEffect(() => {
    GetVendorDetailsById();

  }, []);

  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
          <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/ListofLeads">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Edit Lead</h2>
</div>      </div>
     </div>
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
<div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
         
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                <input type="text" name="fullName"  {...register("fullName", { required: "Full Name Required" })} placeholder="Full Name" className={`form-control basic-form  ${errors.fullName ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.fullName?.message}</div>
            <div className="mt-4">      
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Email</Tooltip>)}>
                <input type="email"  name="email" {...register("email")}  placeholder="Email" className={`form-control basic-form`} />
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.email?.message}</div> */}
              <div className="mt-4">
                              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Name</Tooltip>)}>
                <input type="text" name="companyName" {...register("companyName")} placeholder="Company Name" className={`form-control basic-form`}/>
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.companyName?.message}</div> */}

        </div>
        <div className="mt-4">
                              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Website URL</Tooltip>)}>
                <input type="text" name="websiteURL" {...register("websiteURL")} placeholder="Company Website URL" className={`form-control basic-form`}/>
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.websiteURL?.message}</div> */}

        </div>
         </div>
         <div className="mt-4"> 
      </div>
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>

                <input
                  placeholder='Mobile Number'
                  type="text"
                  min="0"
                  title=''
                  name="phoneNumber"
                  disabled={isDisabled}
                  {...register("phoneNumber" , { required: "Mobile Number Required" })}
                  className={`form-control basic-form ${errors.phoneNumber ? 'is-invalid' : ''}`}

                />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.phoneNumber?.message}</div>

             
              <div className="mt-4"> 
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Description</Tooltip>)}>
                <input type="text" title="" name="domain" {...register("domain")} placeholder="Description" className={`form-control basic-form`} />
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.domain?.message}</div> */}
              <div className="mt-4">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Date of Birth</Tooltip>)}>
                <input type="date" title="" name="dateOfBirth" {...register("dateOfBirth")} placeholder="Date of Birth" className={`form-control basic-form`} />
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.dateOfBirth?.message}</div> */}
        </div>
        <div className="mt-4">
        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Linkedin URL</Tooltip>)}>
                <input type="text" name="linkdinUrl" {...register("linkdinUrl")} placeholder="Linkedin URL" className={`form-control basic-form`}/>
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.linkdinUrl?.message}</div> */}

        </div>
         </div>
           </div>

          </div>
         
          <div className="row mt-4 p-0">
            <div className="col-12">
            <Link to="/Employer/ListofLeads"> 
             <button style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                        Cancel
                      </button>
                      </Link>
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Update
              </button> &nbsp;&nbsp;&nbsp;
            </div>
        </div>
        </form>
        </div></div>
                </div>
  </section>
    </ConsultantLayout>
  );
}

export default EditLead;